import React from 'react';
import Button from './Button';

const ILLUSTRATIONS = {
  empty: (
    <svg width="120" height="100" viewBox="0 0 120 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="20" y="30" width="80" height="55" rx="12" fill="#F0F0F5" stroke="#E4E4EC" strokeWidth="1.5" />
      <rect x="32" y="44" width="36" height="4" rx="2" fill="#E4E4EC" />
      <rect x="32" y="54" width="56" height="3" rx="1.5" fill="#E4E4EC" />
      <rect x="32" y="62" width="44" height="3" rx="1.5" fill="#E4E4EC" />
      <rect x="32" y="70" width="28" height="3" rx="1.5" fill="#E4E4EC" />
      <circle cx="85" cy="25" r="18" fill="#F0EDFB" stroke="#533CD2" strokeWidth="1.5" strokeDasharray="4 3" />
      <path d="M79 25L83 29L91 21" stroke="#533CD2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  search: (
    <svg width="120" height="100" viewBox="0 0 120 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="52" cy="45" r="25" fill="#F0F0F5" stroke="#E4E4EC" strokeWidth="1.5" />
      <circle cx="52" cy="45" r="15" fill="white" stroke="#E4E4EC" strokeWidth="1.5" />
      <line x1="66" y1="58" x2="82" y2="74" stroke="#B3B7C0" strokeWidth="3" strokeLinecap="round" />
      <path d="M48 42C48 42 50 38 55 38" stroke="#E4E4EC" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  ),
  chart: (
    <svg width="120" height="100" viewBox="0 0 120 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="15" y="20" width="90" height="65" rx="12" fill="#F0F0F5" stroke="#E4E4EC" strokeWidth="1.5" />
      <rect x="30" y="60" width="10" height="15" rx="3" fill="#E4E4EC" />
      <rect x="46" y="45" width="10" height="30" rx="3" fill="#E4E4EC" />
      <rect x="62" y="35" width="10" height="40" rx="3" fill="#F0EDFB" stroke="#533CD2" strokeWidth="1" />
      <rect x="78" y="50" width="10" height="25" rx="3" fill="#E4E4EC" />
      <circle cx="95" cy="20" r="12" fill="#F0EDFB" stroke="#533CD2" strokeWidth="1.5" strokeDasharray="4 3" />
      <path d="M91 20L94 23L99 17" stroke="#533CD2" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
};

const EmptyState = ({ icon: Icon, illustration = 'empty', title, message, actionLabel, onAction }) => (
  <div className="card p-10 text-center animate-fade-in">
    <div className="flex justify-center mb-4">
      {Icon ? (
        <div className="w-14 h-14 rounded-2xl bg-pw-surface flex items-center justify-center">
          <Icon className="w-7 h-7 text-pw-border" />
        </div>
      ) : (
        ILLUSTRATIONS[illustration] || ILLUSTRATIONS.empty
      )}
    </div>
    <h3 className="text-sm font-bold text-pw-text mb-1">{title}</h3>
    <p className="text-xs text-pw-muted max-w-xs mx-auto">{message}</p>
    {actionLabel && onAction && (
      <div className="mt-4">
        <Button onClick={onAction}>{actionLabel}</Button>
      </div>
    )}
  </div>
);

export default EmptyState;
